import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

async function readError(response) {
  try {
    const data = await response.json();
    return data.message || data.title || `خطأ ${response.status}`;
  } catch {
    return `خطأ ${response.status}`;
  }
}

export const fetchAdminUsers = async () => {
  const response = await fetch(`${API_BASE_URL}/Auth/users`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const createAdminUser = async ({ email, password, role }) => {
  const response = await fetch(`${API_BASE_URL}/Auth/users`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ email, password, role }),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const updateAdminUser = async (id, payload) => {
  const response = await fetch(`${API_BASE_URL}/Auth/users/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const deactivateAdminUser = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Auth/users/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};
